export default {
  uuid: null,
  isEditing: false,
  currentStep: 0,
  steps: ["Informações", "Horários", "Usuários"],
  stepNameRoutes: [0, "pos-create", ""],
  optionsStates: [],
  pos: {
    chain: "",
    cnpj: null,
    name: "",
    code: null,
    active: true,
    noNumber: false,
    users: [],
  },
  filter: {
    chain: [],
    pos: "",
    areasCode: "",
    uf: "",
    city: "",
    status: ""
  },
  optionsStatus: [
    { value: "active=1", text: "Ativo" },
    { value: "active=0", text: "Inativo" }
  ],
  allRolesList: []
}
